import { render, staticRenderFns } from "./Replacement.vue?vue&type=template&id=10ae12de&scoped=true&"
import script from "./Replacement.vue?vue&type=script&lang=js&"
export * from "./Replacement.vue?vue&type=script&lang=js&"
import style0 from "./Replacement.vue?vue&type=style&index=0&id=10ae12de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae12de",
  null
  
)

component.options.__file = "Replacement.vue"
export default component.exports